<template>
    <div class="task-content">
        <!-- 上方筛选条件 -->
        <div class="task-filter">
            <!-- 左侧搜索，单位，任务状态 -->
            <div class="filter-left">
                <!-- 搜索 -->
                <SearchControl :searchWidth="388" placeholder="搜索站点编号/钻孔ID/行政区划" @searchAction="searchAction"></SearchControl>
                <!-- 选择全部单位 -->
                <el-select v-model="unitValue" placeholder="选择全部单位" @change="queryWithDept">
                    <el-option
                    v-for="item in unitArray"
                    :key="item.id"
                    :label="item.deptName"
                    :value="item.id">
                    </el-option>
                </el-select>
                <!-- 选择任务状态 -->
                <el-select v-model="statusValue" placeholder="任务状态" @change="queryWithStatus">
                    <el-option
                    v-for="item in statusArray"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <!-- 右侧导出和下载报告按钮 -->
            <div class="filter-right">
                <button @click="filterEpxortDrill" class="export">条件导出</button>
                <DownloadExcel
                    :data="selectedDataList"
                    :export-fields="fieldsObj"
                    name="钻孔数据.xls"
                >
                    <button @click="exportDrill" class="export" :disabled="!selectedDataList || selectedDataList.length == 0" :class="{ disabled: !selectedDataList || selectedDataList.length == 0 }">导出</button>
                </DownloadExcel>
                <button @click="downloadReport" :disabled="!selectedDataList || selectedDataList.length == 0" :class="{ disabled: !selectedDataList || selectedDataList.length == 0 }">下载报告</button>
            </div>
        </div>
        <!-- 列表 -->
        <div class="task-list gq-table">
            <el-table
                ref="multipleTable"
                :data="dataList"
                style="width: 100%"
                :border="true"
                :row-key="getRowKey"
                @selection-change="handleSelectionChange"
                @cell-click="clickItem"
            >
                <el-table-column
                    type="selection"
                    width="42"
                    fixed="left"
                    :reserve-selection="true"
                >
                </el-table-column>
                <!-- 站点编号 -->
                <el-table-column
                    label="站点编号"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zdId }}</div>
                            <span class="single-show">{{ scope.row.zdId }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 站点名称 -->
                <el-table-column
                    label="站点名称"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zdName }}</div>
                            <span class="single-show">{{ scope.row.zdName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔ID -->
                <el-table-column
                    label="钻孔ID"
                    width="80"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zkId }}</div>
                            <span class="single-show">{{ scope.row.zkId }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 行政区划 -->
                <el-table-column
                    label="行政区划"
                    width="206"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.province + scope.row.city + scope.row.county + scope.row.town }}</div>
                            <span class="single-show">{{ scope.row.province + scope.row.city + scope.row.county + scope.row.town }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔勘察经度 -->
                <el-table-column
                    label="钻孔勘察经度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.planLon }}</div>
                            <span class="single-show">{{ scope.row.planLon }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔勘察纬度 -->
                <el-table-column
                    label="钻孔勘察纬度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.planLat }}</div>
                            <span class="single-show">{{ scope.row.planLat }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 实际开孔经度 -->
                <el-table-column
                    label="实际开孔经度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.userInputLon != 0 ? scope.row.userInputLon : (scope.row.phoneLocationLon != 0 ? scope.row.phoneLocationLon: "")  }}</div>
                            <span class="single-show">{{ scope.row.userInputLon != 0 ? scope.row.userInputLon : (scope.row.phoneLocationLon != 0 ? scope.row.phoneLocationLon: "") }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 实际开孔纬度 -->
                <el-table-column
                    label="实际开孔纬度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.userInputLat != 0 ? scope.row.userInputLat : (scope.row.phoneLocationLat != 0 ? scope.row.phoneLocationLat: "")  }}</div>
                            <span class="single-show">{{ scope.row.userInputLat != 0 ? scope.row.userInputLat : (scope.row.phoneLocationLat != 0 ? scope.row.phoneLocationLat: "")  }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔深度 -->
                <el-table-column
                    label="钻孔深度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zkHeight }}</div>
                            <span class="single-show">{{ scope.row.zkHeight }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 波速测试深度 -->
                <el-table-column
                    label="波速测试深度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.testHeight  }}</div>
                            <span class="single-show">{{ scope.row.testHeight  }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 施工单位 -->
                <el-table-column
                    label="施工单位"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.xgdwName }}</div>
                            <span class="single-show">{{ scope.row.xgdwName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 施工队 -->
                <el-table-column
                    label="施工队"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.xgdName }}</div>
                            <span class="single-show">{{ scope.row.xgdName ? scope.row.xgdName : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 开孔日期 -->
                <el-table-column
                    label="开孔日期"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.startDate }}</div>
                            <span class="single-show">{{ scope.row.startDate ? scope.row.startDate : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 终孔日期 -->
                <el-table-column
                    label="终孔日期"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.endDate }}</div>
                            <span class="single-show">{{ scope.row.endDate ? scope.row.endDate : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 任务状态 -->
                <el-table-column
                    label="任务状态"
                    width="100"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ judgeStatus(scope.row.status) }}</div>
                            <span class="single-show">{{ judgeStatus(scope.row.status) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 报告提交时间 -->
                <el-table-column
                    label="报告提交时间"
                    width="120"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false" :disabled="!scope.row.docDate">
                            <div slot="content">{{ scope.row.docDate }}</div>
                            <span class="single-show">{{ scope.row.docDate ? scope.row.docDate : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
            <PaginationView :currentPage="1" :pageSize="pageSize" :total="total"></PaginationView>
        </div>
        <!-- 数据详情 -->
        <DataDetail ref="dataDetail"></DataDetail>
    </div>
</template>
<script>
import PaginationView from '../../../components/PaginationView.vue'
import SearchControl from '../../../components/SearchControl.vue'
import DataDetail from './DataDetail.vue'
import {GetDrillDataList, ExportZkDataList } from '@/http/api/api-hb'
import { saveAs } from 'file-saver'

export default {
    components: { PaginationView, SearchControl, DataDetail },
    props: {
        unitList: Array
    },
    data() {
        return {
            // 单位的值
            unitValue: 0,
            // 选择单位的列表
            unitArray: [],
            // 选择的状态
            statusValue: -1,
            // 状态数组
            statusArray: [
                {
                    id: -1,
                    name: '全部'
                },
                {
                    id: 0,
                    name: '未开始'
                },
                {
                    id: 1,
                    name: '施工进行中'
                },
                {
                    id: 2,
                    name: '施工已完成'
                },
                {
                    id: 3,
                    name: '报告已提交'
                },
            ],
            // 数据列表
            dataList: [],
            // 已选中数据列表
            selectedDataList: [],
            fieldsObj: {
                 '站点编号': 'zdId',
                '站点名称': 'zdName',
                '钻孔ID': 'zkId',
                '行政区划': 'address',
                '钻孔勘查经度': 'planLon',
                '钻孔勘查纬度': 'planLat',
                '实际开孔经度': 'realLon',
                '实际开孔纬度': 'realLat',
                '钻孔深度': 'zkHeight',
                '孔口高程': 'zkElevation',
                '施工队': 'xgdName',
                '开孔日期': 'startDate',
                '终孔日期': 'endDate',
                '任务状态': 'statusValue',
                '报告提交时间': 'docDate'
            },
            // 关键字
            keywords: null,
            // 分页
            pageSize: 13,
            pageNumber: 1,
            total: 0,
            // 本地存储的user
            localUser: null
        }
    },
    watch: {
        unitList() {
            this.unitArray = [{ id: 0, deptName: '全部施工单位'}, ...this.unitList]
            this.getDrillDataList()
        }
    },
    computed: {
        xgdwIds() {
            let ids = []
            this.unitList.filter(unit => {
                ids.push(unit.id)
            })
            return ids.join(',')
        }
    },
    mounted() {
        this.localUser = JSON.parse(localStorage.getItem('user'))
    },
    methods: {
        // 获取钻孔列表
        getDrillDataList() {
            const params = {
                // xgdwId: this.unitObj.id,
                current: this.pageNumber,
                limit: this.pageSize,
                keyword: this.keywords
            }
            if (this.localUser.role == 1) {
                if (this.unitValue == 0) {
                    params.xgdwId = this.xgdwIds
                } else {
                    params.xgdwId = this.unitValue
                }
            } else {
                if (this.unitValue != 0) {
                    params.xgdwId = this.unitValue
                }
            }
            if (this.statusValue != -1) {
                params.status = this.statusValue
            }
            if (this.unitValue != 0) {
                params.xgdwId = this.unitValue
            }
            GetDrillDataList(params).then(res => {
                if (res.code == 200) {
                    this.total = res.data.total
                    this.dataList = res.data.rows
                } else {
                    this.$message({ type: 'warning', message: res.msg })
                }
            })
        },
        // 搜索
        searchAction(keywords) {    
            this.keywords = keywords
            this.pageNumber = 1
            this.getDrillDataList()
        },
        // 根据状态
        queryWithStatus() {
            this.pageNumber = 1
            this.getDrillDataList()
        },
        queryWithDept() {
            this.pageNumber = 1
            this.getDrillDataList()
        },

        filterEpxortDrill(){
            const params = {
                keyword: this.keywords
            }
            if (this.localUser.role == 1) {
                if (this.unitValue == 0) {
                    params.xgdwId = this.xgdwIds
                } else {
                    params.xgdwId = this.unitValue
                }
            } else {
                if (this.unitValue != 0) {
                    params.xgdwId = this.unitValue
                }
            }
            if (this.statusValue != -1) {
                params.status = this.statusValue
            }
            if (this.unitValue != 0) {
                params.xgdwId = this.unitValue
            }
            //条件导出数据
            ExportZkDataList(params).then(res => {
                // 生成blob文本
                const blob = new Blob([res], {
                    type: "application/vnd.ms-excel;",
                });
                const filename = '钻孔数据.xlsx'//decodeURIComponent(res.headers["content-disposition"].split("''")[1])
                saveAs(blob, filename);
            })
        },
        // 导出任务
        exportDrill() {
            // this.$refs.multipleTable.clearSelection()
        },
        // 选中一行后
        handleSelectionChange(selection) {
            this.selectedDataList = selection.filter(zk => {
                zk.address = zk.province + zk.city + zk.county + zk.town
                if (zk.status == 0) {
                    zk.statusValue = '未开始'
                } else if (zk.status == 1) {
                    zk.statusValue = '施工进行中'
                } else if (zk.status == 2) {
                    zk.statusValue = '施工已完成'
                } else if (zk.status == 3) {
                    zk.statusValue = '报告已提交'
                }
                zk.realLon = this.getActualLon(zk)
                zk.realLat = this.getActualLat(zk)
                return zk
            })
        },
        // 点击一行后
        clickItem(row) {
            this.$refs.dataDetail.showDataDetail(row)
        },
        // 根据状态转文字
        judgeStatus(status) {
            if (status == 0) {
                return '未开始'
            } else if (status == 1) {
                return '施工进行中'
            } else if (status == 2) {
                return '施工已完成'
            } else if (status == 3) {
                return '报告已提交'
            }
        },
        // 下载报告
        downloadReport() {
            let names = []
            let urls = []
            this.selectedDataList.filter(item => {
                if (item.docPath && item.docPath.length > 0) {
                    names.push(item.zkId)
                    urls.push(item.docPath)
                }
            })
            if (names.length == 0) {
                this.$message.warning('所选数据都未上传报告')
                return
            }
            this.$confirm(`确定要下载钻孔编号为“${names.toString()}”的报告吗？`, '温馨提示', {
                confirmButtonText: '下载',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                urls.filter(url => {
                    window.open(url)
                })
                // this.$refs.multipleTable.clearSelection()
            }).catch(() => {
                window.console.log('取消退出');
            })
        },
        // 获取key
        getRowKey(row) {
            return row.id + ''
        },
        // 分页请求
        paginationRequestPage(page){
            this.pageNumber = page
            // console.log(this.pageNumber)
            this.getDrillDataList()
        },
        // 获取实际经度
        getActualLon(data) {
            if (data.userInputLon) return data.userInputLon
            if (data.phoneLocationLon) return data.phoneLocationLon
            return '-'
        },
        // 获取实际纬度
        getActualLat(data) {
            if (data.userInputLat) return data.userInputLat
            if (data.phoneLocationLat) return data.phoneLocationLat
            return '-'
        },
    },
}
</script>
<style src="../../../assets/css/gq_table.css" scoped></style>
<style scoped>
    .task-content {
        width: 100%;
        height: 100%;
        background: #fff;
        border-radius: 6px;
    }
    /* 上方筛选 */
    .task-content .task-filter {
        width: calc(100% - 32px);
        height: 40px;
        padding: 20px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    /* 筛选左侧 */
    .task-content .task-filter .filter-left {
        display: flex;
    }
    /* 筛选右侧 */
    .task-content .task-filter .filter-right {
        min-width: 252px;
        display: flex;
    }
    .task-content .task-filter .filter-right button {
        width: 120px;
        height: 40px;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #fff;
        background: #0054A0;
    }
    .task-content .task-filter .filter-right button.disabled {
        color: #CCCCCC;
        background: #F0F0F0;
    }
    .task-content .task-filter .filter-right .export {
        margin-right: 12px;
    }
    /* 选择器 */
    .filter-left /deep/ .el-select {
        width: 165px;
        height: 40px;
        background: #F4F4F4;
        margin-right: 16px;
    }
    .filter-left /deep/ .el-select .el-input__inner {
        border: none;
        height: 40px;
        background: #F4F4F4;
        border-radius: 6px;
        font-size: 16px;
        color: #181818;
    }
    .filter-left /deep/ .el-select .el-input.is-focus .el-input__inner {
        border-radius: 6px;
        border: none;
    }
    /* 列表 */
    .task-content .task-list {
        width: calc(100% - 32px);
        height: calc(100% - 128px);
        padding: 0 16px;
    }
    /* 分页 */
    .task-content .pagination {
        width: 100%;
        height: 48px;
    }
    *::-webkit-scrollbar {
        width:7px; 
        height:20px; 
        background-color:transparent;
        }
</style>